<app-block-wrapper [_editable]="_editable" [style]="style">
  <form [formGroup]="form" (ngSubmit)="submit()" #ngForm="ngForm" [class.submitted]="ngForm.submitted">
    <ng-container *ngFor="let field of fields">
      <app-input-field [control]="form.controls[field.label]" *ngIf="field.component === 'FormField'">
        <input [type]="field.type" [formControlName]="field.label" *ngIf="field.type !== 'textarea'" />
        <textarea
          *ngIf="field.type === 'textarea'"
          [formControlName]="field.label"
          [name]="field.label"
          [autocomplete]="field.label | lowercase | replace : ' ' : '-'"
        ></textarea>
        <label>{{ field.label }}</label>
      </app-input-field>

      <app-input-field [control]="form.controls['name']" *ngIf="field.component === 'FormNameField'">
        <input [type]="field.type" [formControlName]="'name'" />
        <label>Name</label>
      </app-input-field>
    </ng-container>

    <button
      appButton
      name="contact-form-send"
      location="body"
      color="primary"
      spacing="full"
      class="cta"
      height="4"
      size="3"
    >
      <span [class.hidden-text]="sending">{{ ctaText }}</span>
      <app-loading-indicator *ngIf="sending" color="white" size="small" class="button-loading-indicator">
      </app-loading-indicator>
    </button>
  </form>
</app-block-wrapper>
